<template>
	<section class="section">
		<h1 class="title">All Recipes</h1>
		<RecipeList v-bind:recipes="recipes" v-bind:showCategories="true"></RecipeList>
	</section>
</template>

<script>
	import RecipeList from '@/components/RecipeList.vue'

	import {db} from '@/variables.js'

	export default {
		components: {
			RecipeList
		},
		data: function () {
			return {
				recipes: []
			}
		},
		created: function() {
			var vm = this
			db.query( 'recipes/by_name').then( function( res ) {
				console.log( res )
				vm.recipes = res.rows
			}).catch( function( err ) {
				throw err
			})
		}
	}
</script>
